import script from "./WriteAttribute.vue?vue&type=script&lang=ts&setup=true"
export * from "./WriteAttribute.vue?vue&type=script&lang=ts&setup=true"

import "./WriteAttribute.vue?vue&type=style&index=0&id=a8f2cb66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8f2cb66"]])

export default __exports__